
import { mapGetters } from "vuex";

export default {
  name: "UiReadMoreClamp",
  props: {
    clampLines: {
      type: Number,
      default: 3,
    },
    clampLinesMobile: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      expanded: false,
      showToggle: false,
    };
  },
  computed: {
    ...mapGetters({
      appBreakpoints: "general/getAppBreakpoints",
    }),
    activeClampLines() {
      if (this.appBreakpoints?.lgAndDown && this.clampLinesMobile !== null) {
        return this.clampLinesMobile;
      }
      return this.clampLines;
    },
    contentStyle() {
      if (!this.expanded) {
        return {
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": this.activeClampLines,
          overflow: "hidden",
        };
      }
      return {};
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkOverflow();
    });
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.handleResize);
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    handleResize() {
      this.checkOverflow();
    },
    checkOverflow() {
      const el = this.$refs.textContent;
      if (!el || typeof window === "undefined") return;

      const wasExpanded = this.expanded;
      this.expanded = true;

      this.$nextTick(() => {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxHeight = lineHeight * this.activeClampLines;
        this.showToggle = el.scrollHeight > maxHeight;
        this.expanded = wasExpanded;
      });
    },
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
